export default __webpack_public_path__ + "static/6876-20f5d8d868fab772c1949cd5e24e4027.jpg";